import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";
import PropTypes from "prop-types";

function ActionContent(props: any) {
  const { onEditItem, onViewItem, onDeleteItem } = props;
  return (
    <>
      {onEditItem && (
        <span className="qti-mouseover" onClick={onEditItem} title="Sửa">
          <EditOutlined />
        </span>
      )}
      {onDeleteItem && onEditItem && <Divider type="vertical" />}
      {onDeleteItem && (
        <span className="qti-mouseover" onClick={onDeleteItem} title="Xóa">
          <DeleteOutlined />
        </span>
      )}
      {onViewItem && (onEditItem || onDeleteItem) && (
        <Divider type="vertical" />
      )}
      {onViewItem && (
        <span className="qti-mouseover" onClick={onViewItem} title="Chi tiết">
          <InfoCircleOutlined />
        </span>
      )}
    </>
  );
}

ActionContent.propTypes = {
  onEditItem: PropTypes.func,
  onViewItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  quyen: PropTypes.object,
};

export default ActionContent;
